<div class="stress-factor-wrapper" *ngIf="isVisibleStressFactor">
    <h3 style="margin-bottom: 20px" class="heading">Stress Factors</h3>
    <div class="card card-custom gutter-b card-stretch stress_tab">
        <div class="card-body">
            <mat-tab-group class="tab-wrapper" [(selectedIndex)]="generalTabIndex" (selectedTabChange)="onTabChanged($event)">
                <mat-tab
                    label="Joint"
                    (click)="setUpStressGaugeValue(0)"
                    *ngIf="calcOutput?.input?.calculationType == 0 || calcOutput?.input?.calculationType == 1"
                >
                    <div class="section-scroll">
                        <!-- <div class="card card-custom gutter-b card-stretch ps-5 pe-5" style="box-shadow: none"> -->
                        <div class="stress_section">
                            <app-stressfactor *ngIf="jointStress" [istress]="jointStress"></app-stressfactor>
                        </div>
                        <!-- </div> -->
                    </div>
                </mat-tab>

                <mat-tab label="Bolt" (click)="setUpStressGaugeValue(1)">
                    <div class="section-scroll">
                        <div class="stress_section">
                            <app-stressfactor *ngIf="jointStress" [istress]="jointStress"></app-stressfactor>
                        </div>
                        <div class="row mt-4 mb-4" style="padding: 15px; width: 100%">
                            <div class="col-md-12">
                                <app-torquepattern *ngIf="diagramInfo.torqueSequenceName" [diagramInfo]="diagramInfo"></app-torquepattern>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
